import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  /**
   * Stores object in session.
   *
   * @param      {string}  resource           The resource's name
   * @param      {any}     obj                The object or literal to be stringified
   * @param      {number}  [expiry=60*60*24]  The expiry (in seconds)
   */
  storeInSession(resource: string, obj: any, expiry: number = 60*60*24) {
    sessionStorage.setItem(resource, JSON.stringify(obj));
    sessionStorage.setItem(resource + "_expiry", (new Date().getTime() + expiry * 1000).toString());
  }
  getInSession(resource: string): any {
    let json_str = sessionStorage.getItem(resource);

    if(json_str) {
      let expiry = Number(sessionStorage.getItem(resource + "_expiry"));
      if(new Date() > new Date(expiry)){
        this.removeInSession(resource);
        return null;
      }
      return JSON.parse(json_str);
    } else {
      return null;
    }
  }
  removeInSession(resource: string) {
    sessionStorage.removeItem(resource);
    sessionStorage.removeItem(resource + "_expiry");
  }
  
  /**
   * Stores object in local storage.
   *
   * @param      {string}  resource           The resource's name
   * @param      {any}     obj                The object or literal to be stringified
   * @param      {number}  [expiry=60*60*24]  The expiry (in seconds). Defaults to a year
   */
  storeInLocal(resource: string, obj: any, expiry: number = 60*60*24*365) {
    localStorage.setItem(resource, JSON.stringify(obj));
    localStorage.setItem(resource + "_expiry", (new Date().getTime() + expiry * 1000).toString());
  }
  getInLocal(resource: string): any {
    let json_str = localStorage.getItem(resource);

    if(json_str) {
      let expiry = Number(localStorage.getItem(resource + "_expiry"));
      if(new Date() > new Date(expiry)){
        this.removeInLocal(resource);
        return null;
      }
      return JSON.parse(json_str);
    } else {
      return null;
    }
  }
  removeInLocal(resource: string) {
    localStorage.removeItem(resource);
    localStorage.removeItem(resource + "_expiry");
  }
}
